'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');
var styled = require('styled-components');
var common = require('../../common-9f27a94d.js');
var Icons_Svgs_DeliveryIcon_index = require('../../Icons/Svgs/DeliveryIcon/index.js');
require('../../typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var StyledDeliveryIcon = styled__default['default'](Icons_Svgs_DeliveryIcon_index['default']).withConfig({ displayName: "ww-uikit_StyledDeliveryIcon_ls4hrdb1", componentId: "sc-13d4x41" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    ", "\n    align-self: flex-start;\n"], ["\n    ", "\n    align-self: flex-start;\n"])), common.iconSize);
var StyledDeliveryTimeText = styled__default['default'].span.withConfig({ displayName: "ww-uikit_StyledDeliveryTimeText_ls4hrdb1", componentId: "sc-ebhu4j" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    font-weight: bold;\n"], ["\n    font-weight: bold;\n"])));
var ETAContentWrapper = styled__default['default'].div.withConfig({ displayName: "ww-uikit_ETAContentWrapper_ls4hrdb1", componentId: "sc-13coit0" })(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    padding-top: 12px;\n    padding-bottom: 16px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    padding-top: 12px;\n    padding-bottom: 16px;\n"])));
var ETAInfo = function (_a) {
    var children = _a.children, deliveryTime = _a.deliveryTime, textTestId = _a.textTestId;
    return (React__default['default'].createElement(common.DeliveryInfoBlock, null,
        React__default['default'].createElement(StyledDeliveryIcon, null),
        React__default['default'].createElement(ETAContentWrapper, null,
            React__default['default'].createElement(StyledDeliveryTimeText, { "data-testid": textTestId }, deliveryTime),
            children)));
};
var templateObject_1, templateObject_2, templateObject_3;

exports.default = ETAInfo;
//# sourceMappingURL=index.js.map
